/**
 * Gallery-to-Variant Sync for Empire Theme (v10 — id-based swatch navigation)
 *
 * v9 trusted Empire's native swatch->gallery navigation. That native code
 * computes the target slide as (media.position - 1), which is WRONG whenever
 * any media is missing from the rendered gallery (e.g. POS-only variants whose
 * media are filtered off the storefront). media.position keeps its gaps while
 * the rendered slide indices are compacted, so the native slideTo overshoots —
 * clicking a colour past the first gap shows the wrong image (or clamps to the
 * last slide). See variant-media-hide.liquid for the matching orphan-hide fix.
 *
 * This version drives the gallery itself, by MEDIA ID:
 *   selected variant -> variant.featured_media.id -> slide with that
 *   data-media-id -> slideTo(its real DOM index).
 * Fully independent of media.position / image order.
 *
 * Also retains v9's gallery-to-dropdown sync for non-swatch products (needles).
 */
(function () {
  'use strict';

  function init() {
    var sectionDataEl = document.querySelector(
      'script[data-section-type="static-product"][data-section-data]'
    );
    if (!sectionDataEl) return;

    var sectionData;
    try {
      sectionData = JSON.parse(sectionDataEl.textContent);
    } catch (e) {
      return;
    }

    var product = sectionData.product;
    if (!product || !product.variants || !product.media) return;

    var swiperEl = document.querySelector('.product-gallery__viewer');
    if (!swiperEl || !swiperEl.swiper) return false; // not ready yet
    var swiper = swiperEl.swiper;

    var hasSwatches = document.querySelector('.options-selection__swatches') !== null;

    if (hasSwatches) {
      // --- Variant -> gallery navigation by media id (overrides Empire's
      //     broken position-based slideTo) ---

      // Map media id -> real slide index (skip Swiper's duplicate loop slides)
      var mediaIdToIndex = {};
      var slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      for (var i = 0; i < slides.length; i++) {
        var mid = slides[i].getAttribute('data-media-id');
        if (mid != null && mediaIdToIndex[String(mid)] == null) {
          mediaIdToIndex[String(mid)] = i;
        }
      }

      // Map variant id -> variant (for featured_media lookup)
      var variantsById = {};
      product.variants.forEach(function (v) { variantsById[String(v.id)] = v; });

      function currentVariantId() {
        var inp = document.querySelector(
          'form[action*="/cart/add"] [name="id"], [name="id"]'
        );
        return inp ? inp.value : null;
      }

      function navigateToSelectedVariant() {
        var id = currentVariantId();
        if (!id) return;
        var v = variantsById[String(id)];
        if (!v || !v.featured_media) return;
        var idx = mediaIdToIndex[String(v.featured_media.id)];
        if (idx == null) return;
        if (swiper.activeIndex !== idx) swiper.slideTo(idx);
      }

      // Run AFTER Empire's own change handler so our (correct) slideTo wins.
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-variant-option]')) {
          setTimeout(navigateToSelectedVariant, 0);
        }
      });
      // Swatch clicks also fire change, but cover label clicks explicitly.
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.options-selection__option-value')) {
          setTimeout(navigateToSelectedVariant, 30);
        }
      });

      return; // swatch handling done
    }

    // --- Non-swatch (dropdown) products: gallery -> dropdown sync (v9) ---
    var mediaByPos = {};
    product.media.forEach(function (m) { mediaByPos[m.position] = m.id; });

    var isMultiOption = product.options.length > 1;
    var mediaToVariant = {};
    var mediaToOption1 = {};
    var hasAnyImage = false;

    product.variants.forEach(function (v) {
      if (v.featured_image && v.featured_image.position) {
        var mediaId = String(mediaByPos[v.featured_image.position]);
        if (mediaId) {
          if (isMultiOption) {
            mediaToOption1[mediaId] = v.option1;
          } else {
            mediaToVariant[mediaId] = v;
          }
          hasAnyImage = true;
        }
      }
    });
    if (!hasAnyImage) return;

    var optionSelects = document.querySelectorAll(
      'select.options-selection__input-select'
    );
    if (!optionSelects.length) return;

    var syncing = false;
    swiper.on('slideChange', function () {
      if (syncing) return;
      var activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      var mediaId = activeSlide.getAttribute('data-media-id');
      if (!mediaId) return;

      if (isMultiOption && mediaToOption1[mediaId]) {
        var option1Value = mediaToOption1[mediaId];
        if (optionSelects[0] && optionSelects[0].value !== option1Value) {
          optionSelects[0].value = option1Value;
          syncing = true;
          optionSelects[0].dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(function () { syncing = false; }, 0);
        }
      } else if (mediaToVariant[mediaId]) {
        var variant = mediaToVariant[mediaId];
        var options = [variant.option1, variant.option2, variant.option3];
        var lastSelect = null;
        optionSelects.forEach(function (sel, i) {
          if (options[i] != null) {
            sel.value = options[i];
            lastSelect = sel;
          }
        });
        if (lastSelect) {
          syncing = true;
          lastSelect.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(function () { syncing = false; }, 0);
        }
      }
    });
  }

  // Poll until Swiper is initialized
  var attempts = 0;
  var maxAttempts = 50;
  var timer = setInterval(function () {
    attempts++;
    var result = init();
    if (result !== false || attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, 100);
})();
